import { useTranslation } from 'react-i18next';

import { APIcon } from '@components/atoms/APIcon';

import { TButtonProps } from './types';

export const APButton = ({
  textKey = '',
  text,
  icon,
  className = '',
  onClick,
  variant = 'primary',
  size = 'medium',
  fullWidth = true,
  iconPosition = 'right',
  disabled = false,
}: TButtonProps) => {
  const { t } = useTranslation();

  const variantStyles = {
    primary: 'bg-[#00DBBF] hover:bg-[#79F4E4] text-black',
    secondary: 'bg-[#B4C5C3] hover:bg-[#CBD7D6] text-black',
    tertiary: 'hover:bg-[#F3F6F6] text-[#059986]',
  };

  const sizeStyles = {
    small: 'text-xs py-1 px-2',
    medium: 'text-sm py-2 px-3',
    large: 'text-base py-3 px-4',
  };

  const buttonStyles = `
    ${variantStyles[variant]} 
    ${sizeStyles[size]} 
    ${fullWidth ? 'w-full' : 'w-auto'} 
    rounded-md font-medium transition-colors duration-200
    ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
    my-3
    ${className}
  `;

  return (
    <button onClick={onClick} disabled={disabled} className={buttonStyles}>
      {iconPosition === 'left' && icon && (
        <APIcon
          img={icon}
          alt="Button icon"
          size={size === 'small' ? 10 : size === 'medium' ? 13 : 16}
          className="mr-1"
        />
      )}
      {text ? text : t(textKey)}
      {iconPosition === 'right' && icon && (
        <APIcon
          img={icon}
          alt="Button icon"
          size={size === 'small' ? 10 : size === 'medium' ? 13 : 20}
          className="ml-2"
        />
      )}
    </button>
  );
};
